import { inject } from "@angular/core";
import { Observable } from "rxjs";
import { PagedItemsDatasource } from "src/app/components/base-classes/paged-items-datasource";
import { Location, LocationService, LocationTemplate, Page_LocationTemplate_ } from "src/app/planvue-api";

export class LocationTemplatesDataSource extends PagedItemsDatasource<LocationTemplate> {
    private locationService: LocationService = inject(LocationService);
    public location!: Location;
    public columns: string[] = ["title", "filename", "format", "delete"];
    
    constructor() {
        super();
    }

    override requestItems(pageIndex:number, pageSize: number): Observable<Page_LocationTemplate_> {
        return this.locationService.getTemplates(this.location.id!, pageIndex + 1, pageSize);
    }
} 